document.addEventListener("DOMContentLoaded", () => {
  const wrapper = document.querySelector(".countdown-wrapper");

  if (!wrapper) return;

  const hoursEl = document.getElementById("cd-h");
  const minutesEl = document.getElementById("cd-m");
  const secondsEl = document.getElementById("cd-s");

  if (!hoursEl || !minutesEl || !secondsEl) return;

  // 🔥 FIX IMPORTANTE: forzar parseo seguro
  const endTime = new Date(wrapper.getAttribute("data-end").replace(" ", "T")).getTime();

  if (isNaN(endTime)) {
    console.error("Countdown: fecha inválida ->", wrapper.dataset.end);
    return;
  }

  function updateCountdown() {
    const now = Date.now();
    const distance = endTime - now;

    if (distance <= 0) {
      hoursEl.textContent = "00";
      minutesEl.textContent = "00";
      secondsEl.textContent = "00";
      return;
    }

    const hours = Math.floor(distance / (1000 * 60 * 60));
    const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((distance % (1000 * 60)) / 1000);

    hoursEl.textContent = String(hours).padStart(2, "0");
    minutesEl.textContent = String(minutes).padStart(2, "0");
    secondsEl.textContent = String(seconds).padStart(2, "0");
  }

  updateCountdown();

  const interval = setInterval(updateCountdown, 1000);

  // 🔥 limpieza por seguridad (Shopify themes lo agradecen)
  window.addEventListener("beforeunload", () => {
    clearInterval(interval);
  });
});